import { useNavigate } from "react-router-dom";
import { TbTableFilled } from "react-icons/tb";
import { PiHourglassMediumFill } from "react-icons/pi";
import { SiMicrostrategy } from "react-icons/si";
import { MdOutlineMiscellaneousServices } from "react-icons/md";
import { RiMessageLine } from "react-icons/ri";
import { PiShareNetworkLight } from "react-icons/pi";
import { PiFirstAidKitThin } from "react-icons/pi";
import { GiEarthAmerica } from "react-icons/gi";

import "./Purpose.css";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";

function Purpose() {
  const navigate = useNavigate();

  return (
    <div>
      <Header />
      <div className="purpose">
        <section className="contact__main__section__one">
          <h1>Our Purpose and Values</h1>
        </section>
        <section className="sustainability__main__section__two">
          <h1>
            We are committed to leveraging the vast opportunities within
            Nigeria’s marine and energy sectors and across Africa.
          </h1>
          <hr />
          <h3>
            Our focus is on creating long-term value by delivering exceptional
            services and ensuring customer satisfaction, while fostering strong,
            constructive partnerships with our stakeholders.
          </h3>
          <p>
            We continuously innovate to provide seamless, cost-effective, and
            safe access to our products and services, adapting to meet the
            evolving needs of our clients. Driven by a passion for excellence,
            integrity, and sustainable growth, we aspire to be recognized as
            market leaders in Nigeria’s marine logistics and energy sectors.
          </p>
        </section>
        <section className="purpose__section__one">
          <div className="purpose__section__one__details">
            <h1>Our Values</h1>
            <hr />
            <p>
              At GuineGulf Energy, we are dedicated to delivering expert marine
              and energy solutions that empower African communities, businesses,
              and governments to achieve sustainable growth. Guided by a
              commitment to excellence, innovation, and collaboration, we strive
              to transform Africa's marine and energy industries, creating
              enduring value for our clients and partners.
            </p>
            <h1>Our Vision</h1>
            <hr />
            <p>
              To be a pioneering force in Africa's marine and energy sectors,
              championing innovation and driving sustainable development for a
              positive and lasting impact across the continent.
            </p>
          </div>
          <div className="purpose__section__one__details__display">
            <div>
              <RiMessageLine className="purpose__section__one__explore__icon" />
              <div>
                <h3>communication</h3>
                <p>
                  The Board is committed to maintaining good communication and
                  having constructive dialogue with its shareholders.
                </p>
              </div>
            </div>
            <div>
              <PiShareNetworkLight className="purpose__section__one__explore__icon" />
              <div>
                <h3>Community</h3>
                <p>
                  We recognise that our operations can create a significant
                  economic and social impact. Where we operate, we actively
                  engage with the local community and host government to ensure
                  that we contribute both directly and indirectly to the economy
                  and well-being of the communities within which we work.
                </p>
              </div>
            </div>
            <div>
              <PiFirstAidKitThin className="purpose__section__one__explore__icon" />
              <div>
                <h3>Health and Safety</h3>
                <p>
                  The health and safety of GuineGulf Energy employees,
                  contractors, partners and those directly affected by its
                  business activities is of paramount importance to the Company.
                  We are committed to providing a safe working environment for
                  all and commit to constantly assessing and monitoring health
                  and safety risks and mitigating these to improve our
                  performance.
                </p>
              </div>
            </div>
            <div>
              <GiEarthAmerica className="purpose__section__one__explore__icon" />
              <div>
                <h3>Environment</h3>
                <p>
                  Protecting the environment is fundamental to our business.
                  GuineGulf Energy conducts its operations in a safe and
                  environmentally responsible manner to the highest industry
                  standards. The Company will comply with the legislation of
                  each country in which it operates, raising these minimum
                  requirements when appropriate. It expects that its contractors
                  match these same standards.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="glance__section__three">
          <h1>Learn more about GuineGulf Energy:</h1>
          <div className="glance__section__three__explore">
            <div
              onClick={() => {
                navigate("/about/glance");
              }}
            >
              <TbTableFilled className="glance__section__three__explore__icon" />
              <h1>GuineGulf Energy at a Glance</h1>
              <p>
                GuineGulf Energy is a leading provider of marine and energy
                solutions, dedicated to delivering innovative services across
                trading, logistics, and vessel operations, with a focus on
                sustainable growth and excellence.
              </p>
            </div>
            <div
              onClick={() => {
                navigate("/about/purpose");
              }}
            >
              <PiHourglassMediumFill className="glance__section__three__explore__icon" />
              <h1>Our Purpose</h1>
              <p>
                To create value by delivering reliable, efficient, and
                customized solutions across the marine and energy industries
                while fostering sustainable practices.
              </p>
            </div>
            <div
              onClick={() => {
                navigate("/about/strategy");
              }}
            >
              <SiMicrostrategy className="glance__section__three__explore__icon" />
              <h1>Our Strategy</h1>
              <p>
                Build a comprehensive portfolio of services, including trading,
                marine logistics, vessel handling, equipment leasing, and waste
                management, to support the evolving needs of clients in Nigeria
                and West Africa.
              </p>
            </div>
            <div
              onClick={() => {
                navigate("/operations");
              }}
            >
              <MdOutlineMiscellaneousServices className="glance__section__three__explore__icon" />
              <h1>Our Operations</h1>
              <p>
                Our leadership team combines diverse business expertise and
                extensive industry experience to drive operational excellence
                and innovation in all aspects of our services.
              </p>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
}

export default Purpose;
